import { render } from "./EmiratisationComplianceBanner.vue?vue&type=template&id=d6c846ee&scoped=true"
import script from "./EmiratisationComplianceBanner.vue?vue&type=script&lang=js"
export * from "./EmiratisationComplianceBanner.vue?vue&type=script&lang=js"

import "./EmiratisationComplianceBanner.vue?vue&type=style&index=0&id=d6c846ee&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6c846ee"]])

export default __exports__